module.exports = __webpack_public_path__ + "media/images/surveyactive-fcd72281.png";